import NetInfo from '@react-native-community/netinfo';
import { validateInternetReachableState } from '@utils/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import connectionComponent from './connectivityUtils';

function ConnectivityListener() {
  const [showNoConnection, setConnectionStatus] = useState(false);
  const { t } = useTranslation('common');
  useEffect(() => {
    const unsubscribe = NetInfo.addEventListener(validateInternetReachableState(setConnectionStatus));
    return () => unsubscribe();
  }, []);

  return connectionComponent(showNoConnection, t);
}

export default ConnectivityListener;
